import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'
import { FontAwesomeIcon } from './FontAwesomeIcon'

export const PlaceholderImage: FC<ComponentProps<'div'>> = ({ className }) => {
	return (
		<div className={cx('flex h-full w-full items-center justify-center bg-grey-20', className)}>
			<FontAwesomeIcon icon={['fal', 'image-slash']} size="2xl" className="text-blue-shade-70" />
		</div>
	)
}
